export default __webpack_public_path__ + "static/media/sub_page_program_en.6bbb83e8.svg";